import React from 'react';
import { useNavigate } from 'react-router-dom';
import HomeLayout from '../layout/components/HomeLayout/HomeLayout';
import './NotFound.scss';
import notFoundImg from '@Assets/img/not-found.png';
import { AppRouteURL } from '@Constants/app-route-url.constant';

export const NotFoundFeature = () => {
    const navigate = useNavigate();

    const handleBackHome = () => {
        navigate('/');
    };

    return (
            <div className="not-found-container">
                <div className="not-found-content">
                    <div className="text-wrapper">
                        <h1 className="error-code">404</h1>
                        <h2 className="error-title">Oops! Page Not Found</h2>
                        <p className="error-message">
                            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. 
                            Don't worry, let's get you back on track!
                        </p>
                        <button className="ia-btn ia-btn-primary py-2 px-4" onClick={handleBackHome}>
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
    );
};
